import { Root } from 'components';
import ReactDOM from 'react-dom/client';

console.group('🚀 Deployment info');
console.info('Mode:', import.meta.env.MODE);
console.info('SHA:', import.meta.env.VITE_VERSION);
console.info('Deployed from SAM 🎉');
console.groupEnd();

// biome-ignore lint/style/noNonNullAssertion: react root element is always present
ReactDOM.createRoot(document.getElementById('root')!).render(<Root />);
